namespace nscs.input {
    export class InputManager {

        private static _instance:InputManager = null;

        public static get instance():InputManager {
            return this._instance ? InputManager._instance : InputManager._instance = new InputManager();
        }

        private scene:Phaser.Scene;
        private buttons:Phaser.GameObjects.Image[] = [];

        private JOYSTICK_UP_:Phaser.GameObjects.Image;
        private JOYSTICK_DOWN_:Phaser.GameObjects.Image;
        private JOYSTICK_RIGHT_:Phaser.GameObjects.Image;
        private JOYSTICK_LEFT_:Phaser.GameObjects.Image;

        protected isDowButton:Object;

        constructor() {
            this.isDowButton = {
                'UP': false,
                'DOWN': false,
                'LEFT': false,
                'RIGHT': false
            }
        }

        public isDown(key:string):boolean {
            return this.isDowButton[key];
        }

        public create(scene:Phaser.Scene):void {
            if (!game.device.input.touch) return;

            this.scene = scene;

            this.createJoystick(38, 245);
        }

        public destroy():void {
            if (!game.device.input.touch) return;

            for (let c of this.buttons) {
                this.scene.children.remove(c);
            }
        }

        private createJoystick(x:number, y:number):void {
            const UP:string='UP', RIGHT:string='RIGHT', DOWN:string='DOWN', LEFT:string='LEFT';

            this.JOYSTICK_UP_ = new Phaser.GameObjects.Image(this.scene,405, 0,'arrow');
            this.JOYSTICK_UP_.angle = -90;
            this.JOYSTICK_DOWN_ = new Phaser.GameObjects.Image(this.scene,330, 0,'arrow');
            this.JOYSTICK_DOWN_.angle = 90;
            this.JOYSTICK_RIGHT_ = new Phaser.GameObjects.Image(this.scene,75, 0,'arrow');
            this.JOYSTICK_RIGHT_.angle = 0;
            this.JOYSTICK_LEFT_ = new Phaser.GameObjects.Image(this.scene,0, 0,'arrow');
            this.JOYSTICK_LEFT_.angle = 180;

            this.buttons = [this.JOYSTICK_UP_, this.JOYSTICK_DOWN_, this.JOYSTICK_RIGHT_, this.JOYSTICK_LEFT_];

            for (let c of this.buttons) {
                this.scene.children.add(c);
                c.setOrigin(0.5, 0.5);
                c.setScale(0.7, 0.7);
                c.alpha = 0.3;
                c.x += x;
                c.y += y;
                c.setScrollFactor(0);
                c.setInteractive();
            }

            this.JOYSTICK_UP_.on('pointerdown',()=>{this.isDowButton[UP] = true;}, this);
            this.JOYSTICK_UP_.on('pointerover',()=>{this.isDowButton[UP] = true;}, this);
            this.JOYSTICK_UP_.on('pointerup', ()=>{this.isDowButton[UP] = false;}, this);
            this.JOYSTICK_UP_.on('pointerout', ()=>{this.isDowButton[UP] = false;}, this);

            this.JOYSTICK_DOWN_.on('pointerdown',()=>{this.isDowButton[DOWN] = true;}, this);
            this.JOYSTICK_DOWN_.on('pointerover',()=>{this.isDowButton[DOWN] = true;}, this);
            this.JOYSTICK_DOWN_.on('pointerup', ()=>{this.isDowButton[DOWN] = false;}, this);
            this.JOYSTICK_DOWN_.on('pointerout', ()=>{this.isDowButton[DOWN] = false;}, this);

            this.JOYSTICK_RIGHT_.on('pointerdown',()=>{this.isDowButton[RIGHT] = true;}, this);
            this.JOYSTICK_RIGHT_.on('pointerover',()=>{this.isDowButton[RIGHT] = true;}, this);
            this.JOYSTICK_RIGHT_.on('pointerup', ()=>{this.isDowButton[RIGHT] = false;}, this);
            this.JOYSTICK_RIGHT_.on('pointerout', ()=>{this.isDowButton[RIGHT] = false;}, this);

            this.JOYSTICK_LEFT_.on('pointerdown',()=>{this.isDowButton[LEFT] = true;}, this);
            this.JOYSTICK_LEFT_.on('pointerover',()=>{this.isDowButton[LEFT] = true;}, this);
            this.JOYSTICK_LEFT_.on('pointerup', ()=>{this.isDowButton[LEFT] = false;}, this);
            this.JOYSTICK_LEFT_.on('pointerout', ()=>{this.isDowButton[LEFT] = false;}, this);

            this.keyUpUsed = false;
            this.JOYSTICK_UP_.on('pointerup', ()=>{this.keyUpUsed = false;}, this);
            this.JOYSTICK_UP_.on('pointerout', ()=>{this.keyUpUsed = false;}, this);
        }

        private keyUpUsed:boolean = false;
        public upPressedDownAndReleased():boolean {
            if (!game.device.input.touch) return false;

            return this.isDown('UP') && !this.keyUpUsed;
        }
        public upPressUsed():void {
            if (!game.device.input.touch) return;

            this.keyUpUsed = true;
        }
    }
}
